export default "__VITE_ASSET__DZfuWo_4__"